module.exports = __webpack_public_path__ + "static/media/quots_2.81fd41c1.png";